var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right arrow",
    clipPath: "url(#clip0_302_854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.0685 10.6049C28.0681 10.6048 28.0677 10.6046 28.0672 10.6045L21.1079 8.76246C20.5866 8.62447 20.052 8.93519 19.9139 9.45664C19.7759 9.97802 20.0867 10.5126 20.6081 10.6506L25.2805 11.8873L7.37625 22.2393C6.90933 22.5093 6.74967 23.1066 7.01964 23.5735C7.28962 24.0404 7.88695 24.2001 8.35388 23.9301L26.2581 13.5781L24.9988 18.2445C24.8583 18.7652 25.1665 19.3012 25.6873 19.4417C26.2081 19.5823 26.744 19.2739 26.8845 18.7533L28.7602 11.803C28.7603 11.8026 28.7604 11.8021 28.7605 11.8017C28.9006 11.2798 28.589 10.7434 28.0685 10.6049Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.762939 12.7521) rotate(-30.0359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.65ba11cce965d9311d01ef857b56a419.svg";
export { ForwardRef as ReactComponent };